<template>
  <div ref="fotoPortadaRef" class="fotoportada-container">
    <div class="overlay">
      
      <!-- SECCIÓN CHAMBELANES -->
      <div ref="chambelanesRef" class="corte-seccion">
        <h3 class="corte-titulo anim-item">Chambelanes</h3>
        <ul class="corte-lista">
          <li class="anim-item">Naaman S Gutiérrez</li>
          <li class="anim-item">Diego Ramos</li>
          <li class="anim-item">Xavier Cordova Guerrero</li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'InvitacionQuinceanera',
  setup() {
    const fotoPortadaRef = ref(null)
    const chambelanesRef = ref(null)
    let ctx = null

    onMounted(() => {
      // Contexto de GSAP para un manejo eficiente de memoria en Vue
      ctx = gsap.context(() => {
        const items = chambelanesRef.value.querySelectorAll('.anim-item')

        // Animación activada únicamente al entrar al Viewport
        gsap.from(items, {
          scrollTrigger: {
            trigger: chambelanesRef.value,
            start: 'top 80%', // Se activa cuando la parte superior del contenedor llega al 80% de la pantalla
            toggleActions: 'play none none none', // Se ejecuta una sola vez al hacer scroll hacia abajo
          },
          opacity: 0,
          y: 45,
          scale: 0.9,
          duration: 1.1,
          stagger: 0.25, // Animación secuencial para cada nombre
          ease: 'power3.out'
        })
      }, fotoPortadaRef.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert() // Limpieza de ScrollTrigger al desmontar el componente
    })

    return {
      fotoPortadaRef,
      chambelanesRef
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. ESTILOS BASE Y CONTENEDORES
   ========================================== */
.fotoportada-container {
  position: relative;
  width: 100%;
  min-height: 50vh;
  overflow: hidden;
  background-color: #fff;
  z-index: 1;
  margin-top:-100px;
}

.overlay {
  position: relative;
  width: 100%;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  z-index: 2;
}

/* ==========================================
   2. SECCIÓN CHAMBELANES
   ========================================== */
.corte-seccion {
  width: 100%;
  max-width: 450px;
  text-align: center;
  z-index: 4;
}

.corte-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #B28F60;
  margin-bottom: 24px;
  will-change: transform, opacity;
}

.corte-lista {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.corte-lista li {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  font-weight: 600;
  color: #d789df;
  letter-spacing: 1px;
  will-change: transform, opacity;
}
</style>